import React from 'react';
import Icon from '../Icon';
import { translate } from '../../Services/translation';

const ProductPageRoomvoButton = ({ id }: { id: string | undefined }) => {
  return (
    <button
      data-sku={id}
      className="roomvo-stimr invisible ml-auto flex h-6 items-center gap-1 text-sm font-normal uppercase leading-4 underline"
    >
      <Icon name="cube-focus" className="h-5 w-5" />
      {translate('product-page.wallpaper-simulator.link')}
    </button>
  );
};

export default ProductPageRoomvoButton;
